export default __webpack_public_path__ + "static/FluentWorldsWhitePaperFinal-e3b8f347325a0ddcabe02ba6e047458f.pdf";